<script lang="ts">
  import { browser } from "$app/environment";
  // GDPR consent implementation
  // https://developers.facebook.com/docs/meta-pixel/implementation/gdpr/
  let { track = false } = $props();
  let addFbScript = $state(false);

  if (browser && window) {
    (function (windowObj) {
      if (windowObj.fbq) return;
      let fbqNamespace = (windowObj.fbq = function () {
        if (fbqNamespace.callMethod) fbqNamespace.callMethod.apply(fbqNamespace, arguments);
        else fbqNamespace.queue.push(arguments);
      });
      if (!windowObj._fbq) windowObj._fbq = fbqNamespace;
      fbqNamespace.push = fbqNamespace;
      fbqNamespace.loaded = true;
      fbqNamespace.version = "2.0";
      fbqNamespace.queue = [];
    })(window);

    window.fbq("consent", "revoke");
    window.fbq("init", "223445949151567");
    window.fbq("track", "PageView");
  }

  // `addFbScript` should not toggle off, hence set in effect
  $effect(() => {
    if (track && !addFbScript && window) {
      addFbScript = true;
      window.fbq("consent", "grant");
    } else if (!track && addFbScript && window) {
      window.fbq("consent", "revoke");
    }
  });
</script>

<svelte:head>
  {#if addFbScript}
    <script async src="https://connect.facebook.net/en_US/fbevents.js"></script>
  {/if}
</svelte:head>
